import { Component, OnInit } from '@angular/core';
import { AuthFacadeService } from 'src/app/facades/auth/auth-facade.service';
import { Router } from '@angular/router';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { StorageService } from 'src/app/core/store/storage/storage.service';
// import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent implements OnInit {

  constructor(private authFacadeService: AuthFacadeService, private router: Router, private bottomSheet: MatBottomSheetRef<LogoutComponent>, private storageService: StorageService) { }
  /**
   * for dialog popup
   */
  // @Inject(MAT_DIALOG_DATA) data: { message: string },
  // public dialogRef: MatDialogRef<LogoutComponent>
  ngOnInit(): void {
  }

  // logout
  logout() {
    this.authFacadeService.signOut().then(() => {
      this.storageService.clearAuthSession();
      this.router.navigate(['auth/login']);
    }).catch(() => {
      this.storageService.clearAuthSession();
      this.router.navigate(['auth/login']);
    });
    // this.dialogRef.close();
    this.bottomSheet.dismiss();
  }

  close() {
    this.bottomSheet.dismiss();
  }

}
